import { animate, state, style, transition, trigger } from '@angular/animations';
import { CdkOverlayOrigin, ConnectedPosition } from '@angular/cdk/overlay';
import { Component, Input, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { BehaviorSubject } from 'rxjs';

export interface ICdkOverlayTriggerParams {
  origin?: CdkOverlayOrigin,
  elementWidth?: number;
  isOpen: boolean;
}

@UntilDestroy()
@Component({
  selector: 'app-cdk-overlay',
  templateUrl: './cdk-overlay.component.html',
  styleUrls: ['./cdk-overlay.component.scss'],
  animations: [
    trigger('transformPanel', [
      state('void', style({ opacity: 0 }),),
      transition(
        'void => *',
        animate(
          '300ms cubic-bezier(0, 0, 0.2, 1)',
          style({ opacity: 1 }),
        ),
      ),
      transition(
        '* => void',
        animate('100ms linear', style({ opacity: 0 }))),
    ])
  ],
})
export class CdkOverlayComponent implements OnInit {
  @Input() openTrigger$: BehaviorSubject<ICdkOverlayTriggerParams>;
  @Input() cdkOverlayMinWidth = 180;
  @Input() cdkOverlayMinHeight = 84;
  @Input() overlayPositions: ConnectedPosition[] = [
    { originX: 'center', originY: 'bottom', overlayX: 'center', overlayY: 'top' },
    { originX: 'center', originY: 'bottom', overlayX: 'center', overlayY: 'bottom' },
  ];
  cdkOpen: boolean;
  overlayOrigin: CdkOverlayOrigin;

  cdkOverlayWidth: number;

  constructor() { }

  ngOnInit(): void {
    if (this.openTrigger$) {

      this.openTrigger$.pipe(
        untilDestroyed(this)
      ).subscribe({
        next: value => {
          if (!value.isOpen) {
            this.cdkOpen = false;
            console.log('this.cdkOpen = false');
            return;
          }
          this.overlayOrigin = value.origin;
          this.widthCalculate(value.elementWidth);
          this.cdkOpen = value.isOpen;
        }
      });
    }
  }

  closeCdkOverlay() {
    this.cdkOpen = false;
    this.openTrigger$.next({ isOpen: false });
  }

  private widthCalculate(elementWidth: number) {
    this.cdkOverlayWidth = elementWidth <= this.cdkOverlayMinWidth
      ? this.cdkOverlayMinWidth
      : elementWidth;
  }
}
